import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../config/config";
import { Link } from 'react-router-dom';

const LanguageByChannels = () => {
    const { language } = useParams();
    
    const [channels, setChannels] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchChannelData = async () => {
            setLoading(true);
            try {
                const response = await fetch(`${BASE_URL}/countries`);
                if (!response.ok) throw new Error("Failed to fetch data");

                const data = await response.json();
                setChannels(data); // Store as an array
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchChannelData();

    }, [language]);

    
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;

    return (
        <main className="main">
            <div className="container-fluid">
                <section className="row row--grid">
                    <div className="col-12">
                        <div className="main__title text-capitalize">
                            <h2>Choose Your Country</h2>
                        </div>
                    </div>

                    {channels.length === 0 ? (
                        <div className="col-12">
                            <p>No channels found.</p>
                        </div>
                    ) : (
                        channels.map((channel) => (
                            <div className="col-6 col-sm-4 col-lg-1">
                                <div className="album">
                                    <div className="album__cover">
                                        <img src={channel.flag} alt={`${channel.name} logo`} />
                                        <Link to={`/country/${channel.code}`}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                                                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"/>
                                                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"/>
                                            </svg>
                                        </Link>
                                    </div>
                                    <div className="album__title text-center">
                                        <h3><Link to={`/country/${channel.code}`}>{channel.name}</Link></h3>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </section>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="partners owl-carousel">
                        
                    </div>
                </div>
            </div>
        </main>
    );
};

export default LanguageByChannels;
